export default "/images/vendor/flag-icon-css/flags/1x1/be.svg?914a3c37d1998aa1f6b0bcb231f5f98f";